import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { postNamedCommand, postNamedQuery } from '../service'
import { useAppContext } from '../redux/slices/appContext'
import { QUERY_KEYS } from './queryKeys'

export const useListClientTags = (options = {}) => {
  const { userId } = useAppContext()

  return useQuery({
    queryKey: [QUERY_KEYS.listClientTags, userId],
    queryFn: async () => {
      try {
        return await postNamedQuery('levels', 'list-client-tags', {})
      } catch (e) {
        // Let React Query handle the error
        console.error(e.message || 'Failed to fetch client tags')
      }
    },
    ...options
  })
}

export const useModifyClientTag = () => {
  const { userId } = useAppContext()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (command) => {
      const tagData = {
        tag: {
          groupTypeId: parseInt(command.groupTypeId),
          longName: command.longName,
          description: command.description
        }
      }
      const { data } = await postNamedCommand('levels', 'modify-client-tag', tagData)

      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.searchGroupTypes, userId],
        refetchType: 'all'
      }).catch(console.error)
    }
  })
}
export const useInsertClientTagOption = () => {
  const { userId } = useAppContext()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (command) => {
      const tagOptionData = {
        tagOption: {
          groupTypeId: command.groupTypeId,
          shortName: command.shortName,
          longName: command.longName,
          description: command.description,
          ordinal: command.ordinal,
          colorField: command.colorField
        }
      }
      const { data } = await postNamedCommand('levels', 'create-client-tag-option', tagOptionData)

      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.searchGroups, userId],
        refetchType: 'all'
      }).catch(console.error)
    }
  })
}
export const useModifyClientTagOption = () => {
  const { userId } = useAppContext()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (command) => {
      const tagOptionData = {
        tagOption: {
          groupId: command.groupId,
          groupTypeId: command.groupTypeId,
          shortName: command.shortName,
          longName: command.longName,
          description: command.description,
          ordinal: command.ordinal,
          colorField: command.colorField
        }
      }
      const { data } = await postNamedCommand('levels', 'modify-client-tag-option', tagOptionData)

      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.searchGroups, userId],
        refetchType: 'all'
      }).catch(console.error)
    }
  })
}

export const useDeleteClientTagOption = () => {
  const { userId } = useAppContext()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (command) => {
      const tagOptionData = {
        groupId: command.groupId
      }
      const { data } = await postNamedCommand('levels', 'remove-client-tag-option', tagOptionData)

      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.searchGroups, userId],
        refetchType: 'all'
      }).catch(console.error)
    }
  })
}

export const useDeleteAssetTag = () => {
  const { userId } = useAppContext()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (command) => {
      const tagData = {
        tagId: command.classificationTagId
      }
      const { data } = await postNamedCommand('levels', 'remove-asset-tag', tagData)

      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.classificationTags, userId],
        refetchType: 'all'
      }).catch(console.error)
    }
  })
}

export const useCreateAssetTag = () => {
  const { userId } = useAppContext()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (command) => {
      const tagData = {
        assetTag: {
          classificationTagTypeId: command.typeId,
          longName: command.longName,
          colorField: command.color,
          ordinal: command.ordinal,
          classificationType: command.type,
          shortName: command.shortName
        }
      }
      const { data } = await postNamedCommand('levels', 'create-asset-tag', tagData)

      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.classificationTags, userId],
        refetchType: 'all'
      }).catch(console.error)
    }
  })
}

export const useModifyAssetTag = () => {
  const { userId } = useAppContext()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (command) => {
      const tagData = {
        assetTag: {
          classificationTagId: command.id,
          classificationTagTypeId: command.typeId,
          classificationType: command.type,
          shortName: command.shortName,
          longName: command.longName,
          colorField: command.color,
          ordinal: command.ordinal
        }
      }
      const { data } = await postNamedCommand('levels', 'modify-asset-tag', tagData)

      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.classificationTags, userId],
        refetchType: 'all'
      }).catch(console.error)
    }
  })
}
